import * as React from 'react';
import TFFTypography from '../../styled-components/TFFTypography';
import TFFIcon from '../../styled-components/TFFIcon';
import { useIntl } from 'react-intl';

export const PricingDetailsTitle = () => {
  const intl = useIntl();

  return (
    <div className="tff-pricing-details-title">
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <div className="tff-pricing-details-title-icon">
          <span>
            <TFFIcon iconName="pricetag" color="color-theme-variant" />
          </span>
        </div>
        <TFFTypography
          text={intl.formatMessage({ id: 'pricingDetails.title' }).toUpperCase()}
          fontWeight="bold"
          variant="lead"
        />
      </div>
    </div>
  );
};
